import { render } from "./Services.vue?vue&type=template&id=6fffbd84&scoped=true"
import script from "./Services.vue?vue&type=script&lang=js"
export * from "./Services.vue?vue&type=script&lang=js"

import "@/assets/styles/beneficiary.css?vue&type=style&index=0&id=6fffbd84&scoped=true&lang=css&external"
import "./Services.vue?vue&type=style&index=1&id=6fffbd84&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6fffbd84"]])

export default __exports__